import { FRDClosureTask } from "@nens/brostar/uploadapi-client";
import { SchemaForFormData } from "@nens/shared-utils";

import { getDocsLinkMarkdown, getTitleAddon } from "@/libs/form-utils";
import { FormType } from "@/types/form-types";

import { pickFrdLibraryFields } from "../../../schema/frd-schema-library";

export const getFrdClosureSchema = (
  type: FormType | undefined
): SchemaForFormData<FRDClosureTask> => ({
  type: "object",
  title: `FRD-Beeindigen ${getTitleAddon(type)}`,
  description: `Dit is het FRD Beeindigen formulier. ${getDocsLinkMarkdown("FRD")}`,
  required: ["metadata"],
  properties: {
    metadata: {
      type: "object",
      required: ["projectNumber", "broId", "qualityRegime", "deliveryAccountableParty"],
      properties: pickFrdLibraryFields([
        "projectNumber",
        "broId",
        "qualityRegime",
        "deliveryAccountableParty",
      ]),
    },
  },
});
